import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const AccordionDesignSettings = {
  'accordion-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'accordion-design-search-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
  },

  'accordion-design-typography': {
    'accordion-design-title-typography': {
      phone: getDefaultTypography('headline-small'),
      'phone-landscape': getDefaultTypography('headline-small'),
      tablet: getDefaultTypography('headline-small'),
      'tablet-landscape': getDefaultTypography('headline-small'),
      desktop: getDefaultTypography('headline-small'),
      tv: getDefaultTypography('headline-small'),
    },
    'accordion-design-header-typography': {
      phone: getDefaultTypography('Body Large'),
      'phone-landscape': getDefaultTypography('Body Large'),
      tablet: getDefaultTypography('Body Large'),
      'tablet-landscape': getDefaultTypography('Body Large'),
      desktop: getDefaultTypography('Body Large'),
      tv: getDefaultTypography('Body Large'),
      overflowSetting: {
        phone: getDefaultTypography('Label Medium'),
        'phone-landscape': getDefaultTypography('Label Medium'),
        tablet: getDefaultTypography('Label Medium'),
        'tablet-landscape': getDefaultTypography('Label Medium'),
        desktop: getDefaultTypography('Label Medium'),
        tv: getDefaultTypography('Label Medium'),
      },
      detailPageSetting: {
        phone: getDefaultTypography('Label Medium'),
        'phone-landscape': getDefaultTypography('Label Medium'),
        tablet: getDefaultTypography('Label Medium'),
        'tablet-landscape': getDefaultTypography('Label Medium'),
        desktop: getDefaultTypography('Label Medium'),
        tv: getDefaultTypography('Label Medium'),
      },
    },
    'accordion-design-content-typography': {
      phone: getDefaultTypography('Body Large'),
      'phone-landscape': getDefaultTypography('Body Large'),
      tablet: getDefaultTypography('Body Large'),
      'tablet-landscape': getDefaultTypography('Body Large'),
      desktop: getDefaultTypography('Body Large'),
      tv: getDefaultTypography('Body Large'),
      overflowSetting: {
        phone: getDefaultTypography('Body Medium'),
        'phone-landscape': getDefaultTypography('Body Medium'),
        tablet: getDefaultTypography('Body Medium'),
        'tablet-landscape': getDefaultTypography('Body Medium'),
        desktop: getDefaultTypography('Body Medium'),
        tv: getDefaultTypography('Body Medium'),
      },
    },
    'accordion-design-group-header-typography': {
      phone: getDefaultTypography('Title Medium'),
      'phone-landscape': getDefaultTypography('Title Medium'),
      tablet: getDefaultTypography('Title Medium'),
      'tablet-landscape': getDefaultTypography('Title Medium'),
      desktop: getDefaultTypography('Title Medium'),
      tv: getDefaultTypography('Title Medium'),
      overflowSetting: {
        phone: getDefaultTypography('Label Large'),
        'phone-landscape': getDefaultTypography('Label Large'),
        tablet: getDefaultTypography('Label Large'),
        'tablet-landscape': getDefaultTypography('Label Large'),
        desktop: getDefaultTypography('Label Large'),
        tv: getDefaultTypography('Label Large'),
      },
    },
  },

  // Spacing
  'accordion-design-title-margin': {
    phone: getDefaultMargin([20]),
    'phone-landscape': getDefaultMargin([20]),
    tablet: getDefaultMargin([20]),
    'tablet-landscape': getDefaultMargin([20]),
    desktop: getDefaultMargin([20]),
    tv: getDefaultMargin([20]),
  },
  'accordion-design-component-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'accordion-design-component-padding': {
    phone: getDefaultMargin([20]),
    'phone-landscape': getDefaultMargin([20]),
    tablet: getDefaultMargin([20]),
    'tablet-landscape': getDefaultMargin([20]),
    desktop: getDefaultMargin([20]),
    tv: getDefaultMargin([20]),
  },
  'accordion-design-panel-header-margin': {
    phone: getDefaultMargin([30]),
    'phone-landscape': getDefaultMargin([30]),
    tablet: getDefaultMargin([30]),
    'tablet-landscape': getDefaultMargin([30]),
    desktop: getDefaultMargin([30]),
    tv: getDefaultMargin([30]),
  },
  'accordion-design-panel-content-margin': {
    phone: getDefaultMargin([30]),
    'phone-landscape': getDefaultMargin([30]),
    tablet: getDefaultMargin([30]),
    'tablet-landscape': getDefaultMargin([30]),
    desktop: getDefaultMargin([30]),
    tv: getDefaultMargin([30]),
  },
  'accordion-design-group-header-margin': {
    phone: getDefaultMargin([5]),
    'phone-landscape': getDefaultMargin([5]),
    tablet: getDefaultMargin([5]),
    'tablet-landscape': getDefaultMargin([5]),
    desktop: getDefaultMargin([5]),
    tv: getDefaultMargin([5]),
  },
  'accordion-design-search-margin': {
    phone: getDefaultMargin([0, 0, 12]),
    'phone-landscape': getDefaultMargin([0, 0, 12]),
    tablet: getDefaultMargin([0, 0, 12]),
    'tablet-landscape': getDefaultMargin([0, 0, 12]),
    desktop: getDefaultMargin([0, 0, 12]),
    tv: getDefaultMargin([0, 0, 12]),
  },

  // Alignment
  'accordion-design-alignment-component': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'accordion-design-alignment-title': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'accordion-design-alignment-panel-header': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'accordion-design-alignment-group-header': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'accordion-design-alignment-title-accordion': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'accordion-design-alignment-content-accordion': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'accordion-design-alignment-panel-content': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
  'accordion-design-alignment-group-search': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'accordion-design-group-search-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },

  // color
  'accordion-design-text-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'accordion-design-text-color-solid': {
    dark: 'neutral-100',
    light: 'neutral-100',
  },
  'accordion-design-text-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'accordion-design-text-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'accordion-design-text-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'accordion-design-content-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'accordion-design-content-color-solid': {
    dark: 'neutral-100',
    light: 'neutral-100',
  },
  'accordion-design-content-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'accordion-design-content-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'accordion-design-content-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'accordion-design-group-header-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'accordion-design-group-header-color-solid': {
    dark: 'neutral-100',
    light: 'neutral-100',
  },
  'accordion-design-group-header-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'accordion-design-group-header-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'accordion-design-group-header-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'accordion-design-title-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'accordion-design-title-color-solid': {
    dark: 'neutral-100',
    light: 'neutral-100',
  },
  'accordion-design-title-color-start-gradient': {
    dark: 'primary-60',
    light: 'primary-60',
  },
  'accordion-design-title-color-end-gradient': {
    dark: 'primary-90',
    light: 'primary-90',
  },
  'accordion-design-title-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
  'accordion-design-search-color': {
    phone: 'primary-90',
    'phone-landscape': 'primary-90',
    tablet: 'primary-90',
    'tablet-landscape': 'primary-90',
    desktop: 'primary-90',
    tv: 'primary-90',
  },
  'accordion-design-search-corner-radius': {
    phone: 'medium',
    'phone-landscape': 'medium',
    tablet: 'medium',
    'tablet-landscape': 'medium',
    desktop: 'medium',
    tv: 'medium',
  },
}
